import { IFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureLoader";
import { ILogger } from "esdm-map/dist/logging/ILogger";
import { IFeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureAdd";
import { IVectorLayerSource } from "esdm-map/dist/layers/vector/sources/interfaces/IVectorLayerSource";
import GeoJSON from 'ol/format/GeoJSON';
import * as olExtent from 'ol/extent'
import Filter from "ol/format/filter/Filter";

export class FilteredGeoJsonFeatureLoader implements IFeatureLoader {

    private statusFilters: Array<number>; 
    public constructor() {
        this.statusFilters = [];
    }

    public load = (
        layerSource: IVectorLayerSource,
        featureAdd: IFeatureAdd,
        data: any,
        dataProjection: string,
        displayProjection: string,  
        resolution: number,
        logger: ILogger,
        wktProperty: string = null
    ): [number, number, number, number] =>
    {
        //remove existing features
        let features = layerSource.source.getFeatures();
        features.forEach((feature) => {
            layerSource.source.removeFeature(feature);
        });

        let format: GeoJSON = new GeoJSON();
        let dataBounds = olExtent.createEmpty();

        features = format.readFeatures(data, {
            dataProjection: dataProjection,
            featureProjection: displayProjection
        });

        this.statusFilters = [];

        // Get status filter values from check boxes
        document.querySelectorAll('.StatusFilter').forEach((elem) => {
            if ((elem as HTMLInputElement).checked)
            {
                this.statusFilters.push(+ (elem as HTMLInputElement).getAttribute('data-status-id'));
            }
        });

        features.forEach((feature) => {
            let status: number = + feature.getProperties()["asset_status_id"];
            if (this.statusFilters.includes(status)) {
                featureAdd.addFeature(layerSource, feature, resolution);
            }
        });         

        layerSource.source.forEachFeature((feature) => {
            dataBounds = olExtent.extend(dataBounds, feature.getGeometry().getExtent());
        });

        return dataBounds;
    }
}